var map = {
	"./ActionfiLogo.png": 98,
	"./CognizantLogo.png": 99,
	"./address_image.svg": 100,
	"./ai-agent.svg": 101,
	"./ai-code-generation.svg": 39,
	"./animated_ashutosh.png": 102,
	"./animated_logo.svg": 103,
	"./blogs_image.svg": 104,
	"./building-websites.svg": 37,
	"./cloud_infrastructure.svg": 105,
	"./codeInLogo.png": 106,
	"./contactMail.png": 107,
	"./coursera_logo.png": 108,
	"./dSPACE_Logo.png": 109,
	"./data_science.svg": 110,
	"./deeplearning_ai_logo.png": 111,
	"./delhivery_logo.png": 112,
	"./developerActivity.svg": 113,
	"./dsc_logo.png": 114,
	"./education.svg": 115,
	"./experience.svg": 116,
	"./freecopy_logo.png": 117,
	"./fullstack.svg": 118,
	"./gcp_logo.png": 119,
	"./github_logo.png": 120,
	"./googleAssistant.jpg": 121,
	"./googleAssistant.svg": 122,
	"./google_logo.png": 123,
	"./ibm_logo.png": 124,
	"./intel_logo.jpg": 125,
	"./jsFramework.svg": 126,
	"./legato_logo.png": 127,
	"./manOnTable.svg": 128,
	"./mec_logo.png": 129,
	"./microsoft_logo.png": 130,
	"./mozilla_logo.png": 131,
	"./muffito_logo.png": 132,
	"./nextuLogo.jpg": 133,
	"./nptel_logo.png": 134,
	"./outer-space.svg": 135,
	"./portfolio-website.svg": 40,
	"./portfolio.gif": 136,
	"./programmer.svg": 137,
	"./programming.svg": 138,
	"./projects_image.svg": 139,
	"./pwa.png": 140,
	"./retro-video-game.svg": 38,
	"./saayaHealthLogo.png": 141,
	"./stanford_logo.png": 142,
	"./talksCardBack.svg": 143,
	"./talksCardBackAlt.svg": 144,
	"./tiktok_logo.png": 145,
	"./ui_ux_design.svg": 146,
	"./upb_logo.png": 147,
	"./welcoming.svg": 49
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 34;